import { memo, useMemo } from "react";
import clsx from "clsx";

import classes from "./styles.module.scss";

import { Typography } from "@components/atoms/typography";
import { dashboardCardVariants } from "@components/molecules/dashboardCard/variant";
import type { IDashboardCardProps } from "@components/molecules/dashboardCard/types";
import { Icon } from "@components/atoms/icons";

export const DashboardCard = memo(function DashboardCard({
  card,
}: IDashboardCardProps) {
  const { name, value, key } = card;

  const { color, icon } = dashboardCardVariants[key];

  const valueText = useMemo(() => `${value} +`, [value]);

  return (
    <div
      style={{
        backgroundColor: color,
      }}
      className={clsx(classes.card)}
    >
      <div>
        <Icon name={icon} color={"white"} type={"bold"} fontSize={"xl"} />
      </div>
      <div className={clsx(classes.card__text)}>
        <Typography fontWeight={"semi-bold"} color={"white"}>
          {name}
        </Typography>
      </div>
      <div className={clsx(classes.card__text)}>
        <Typography fontWeight={"semi-bold"} color={"white"}>
          {valueText}
        </Typography>
      </div>
    </div>
  );
});
